module.exports = __webpack_public_path__ + "static/media/areamap.e7e02756.svg";